var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupActionInPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 46,
    viewBox: "0 0 62 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 31.3618,
    width: 56.3938,
    height: 6.76076,
    rx: 3.38038,
    transform: "rotate(-33.3306 0 31.3618)",
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58296 37.2116C6.03067 37.2116 5.58301 37.6594 5.58301 38.2116V39.4583C5.58301 42.5291 8.09551 45.0416 11.1663 45.0416H39.083C42.1538 45.0416 44.6663 42.5291 44.6663 39.4583V33.5958L56.9497 41.9708C57.508 42.2499 58.0663 42.5291 58.6247 42.5291C59.183 42.5291 59.4622 42.5291 60.0205 42.2499C60.858 41.6916 61.4163 40.8541 61.4163 39.7374V11.5416C61.4163 10.4249 60.858 9.58742 60.0205 9.02909C59.183 8.47075 58.0663 8.47075 57.2288 9.02909L44.9455 17.4041V16.3076C44.9455 15.5118 44.061 15.0348 43.396 15.4721L39.5335 18.0123C39.2523 18.1972 39.083 18.5112 39.083 18.8478V39.4583H11.1663V39.2116C11.1663 38.1071 10.2709 37.2116 9.16634 37.2116H8.88703C8.88703 37.2116 7.71471 37.2116 6.58296 37.2116ZM44.6663 26.6166L55.833 34.1541V16.5666L44.6663 24.1041V26.6166Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2357 11.3771C25.0725 11.4844 24.8815 11.5416 24.6862 11.5416H11.1663V20.0905C11.1663 20.427 10.997 20.741 10.7158 20.926L7.13248 23.2825C6.46753 23.7198 5.58301 23.2429 5.58301 22.447V11.5416C5.58301 8.47075 8.09551 5.95825 11.1663 5.95825H30.135C31.1276 5.95825 31.5138 7.24833 30.6844 7.79377L25.2357 11.3771Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupActionInPrivate);
export default __webpack_public_path__ + "static/media/popup-action-in-private.5c7e23c11fdc719289e296d9d24d6a9b.svg";
export { ForwardRef as ReactComponent };